"use strict";
/**
 * Merge Unified API Types
 *
 * This module provides types for the Merge Unified API integration,
 * covering both ATS (Applicant Tracking System) and CRM categories.
 *
 * Merge Documentation: https://docs.merge.dev/
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.isRecruiterLiteSourced = exports.isSalesNavSourced = exports.hasLinkedInData = exports.isMergeSynced = exports.mergeCandidateToScoutCandidate = exports.scoutCandidateToMergeCandidate = void 0;
// ============================================================================
// Mapping Utilities
// ============================================================================
/**
 * Maps a ScoutCandidate to Merge ATS Candidate format for syncing to external ATS
 */
function scoutCandidateToMergeCandidate(scout) {
    var _a, _b, _c, _d;
    return {
        firstName: (_a = scout.firstName) !== null && _a !== void 0 ? _a : (_b = scout.name) === null || _b === void 0 ? void 0 : _b.split(' ')[0],
        lastName: (_c = scout.lastName) !== null && _c !== void 0 ? _c : (_d = scout.name) === null || _d === void 0 ? void 0 : _d.split(' ').slice(1).join(' '),
        // Note: emailAddresses and phoneNumbers are arrays in Merge
        // This is a simplified mapping - full implementation would handle arrays
        title: scout.headline,
        // Additional mapping would be needed for full integration
    };
}
exports.scoutCandidateToMergeCandidate = scoutCandidateToMergeCandidate;
/**
 * Maps a Merge ATS Candidate to ScoutCandidate format for importing from external ATS
 */
function mergeCandidateToScoutCandidate(merge, linkedInExtensions) {
    var _a, _b, _c, _d;
    return {
        firstName: (_a = merge.firstName) !== null && _a !== void 0 ? _a : undefined,
        lastName: (_b = merge.lastName) !== null && _b !== void 0 ? _b : undefined,
        name: merge.firstName && merge.lastName
            ? `${merge.firstName} ${merge.lastName}`
            : undefined,
        headline: (_c = merge.title) !== null && _c !== void 0 ? _c : undefined,
        linkedin: linkedInExtensions,
        mergeIntegration: {
            mergeRemoteId: (_d = merge.id) !== null && _d !== void 0 ? _d : undefined,
            category: 'ats',
            syncStatus: 'synced',
            lastSyncedAt: new Date(),
            lastSyncDirection: 'pull',
        },
    };
}
exports.mergeCandidateToScoutCandidate = mergeCandidateToScoutCandidate;
// ============================================================================
// Type Guards
// ============================================================================
/**
 * Check if a candidate has been synced to an external ATS via Merge
 */
function isMergeSynced(candidate) {
    var _a;
    return !!((_a = candidate.mergeIntegration) === null || _a === void 0 ? void 0 : _a.mergeRemoteId);
}
exports.isMergeSynced = isMergeSynced;
/**
 * Check if a candidate has LinkedIn data
 */
function hasLinkedInData(candidate) {
    var _a;
    return !!((_a = candidate.linkedin) === null || _a === void 0 ? void 0 : _a.linkedInId);
}
exports.hasLinkedInData = hasLinkedInData;
/**
 * Check if a candidate was sourced from Sales Navigator
 */
function isSalesNavSourced(candidate) {
    var _a;
    return ((_a = candidate.linkedin) === null || _a === void 0 ? void 0 : _a.linkedInIdType) === 'sales_navigator';
}
exports.isSalesNavSourced = isSalesNavSourced;
/**
 * Check if a candidate was sourced from Recruiter Lite
 */
function isRecruiterLiteSourced(candidate) {
    var _a;
    return ((_a = candidate.linkedin) === null || _a === void 0 ? void 0 : _a.linkedInIdType) === 'recruiter_lite';
}
exports.isRecruiterLiteSourced = isRecruiterLiteSourced;
